<template>
  <div class="green lighten-4 pt-2 pb-2">
    <div class="logos d-flex align-center">
      <div
        v-for="(item, index) in itemsFDayaDukungTypeComputed"
        :key="index"
        class="logos-slide d-flex"
      >
        <v-card
          elevation="0"
          class="my-1 rounded-lg text-center green lighten-4"
        >
          <v-avatar
            size="100"
            @click="showDialog(item)"
          >
<!--            @click="item.description === 'PDRB' ? pdrbDialogShow(item) : ''"-->
            <v-img
              :lazy-src="lookupImageUrlLazy(item)"
              :src="lookupImageUrlDayaDukungType(item)"
              contain
              height="100px"
              max-width="100px"
            ></v-img>
          </v-avatar>
          <v-card-text class="text-center">
            <div class="width-text">
              <div class="font-weight-bold">
                {{ item.description }}
              </div>
              <div v-if="item.calcData.nilaiAkhir" class="font-weight-bold">
                {{ formatter(item.calcData.nilaiAkhir) }}
              </div>
              <div class="caption grey--text text--darken-1">
                <span class="mr-1" v-if="item.calcData.tahunPalingAkhir">{{item.calcData.tahunPalingAkhir}}</span>
                <span  v-if="item.calcData.sumberAkhir">*{{ item.calcData.sumberAkhir }}</span>
              </div>
            </div>

          </v-card-text>

        </v-card>
      </div>
    </div>
    <PdrbDialog
      :itemsFDayaDukung="itemsFDayaDukung"
      :itemsFDayaDukungType="itemsFDayaDukungType"
      ref="refPdrbDialog"
    ></PdrbDialog>
    <DayaDukungBannerDialog
        :itemsFDayaDukung="itemsFDayaDukung"
        ref="refDayaDukungBannerDialog"
    ></DayaDukungBannerDialog>
  </div>
</template>

<script>
import FileService from "@/services/apiservices/file-service";
import PdrbDialog from "./PdrbDialog";
import DayaDukungBannerDialog from "@/components/public-daya-dukung-banner/DayaDukungBannerDialog.vue";

export default {
  props: {
    itemsFDayaDukung: Array,
    itemsFDayaDukungType: Array,
  },
  data() {
    return {
    };
  },
  components: {
    DayaDukungBannerDialog,
    PdrbDialog,
  },
  computed: {
    itemsFDayaDukungTypeComputed() {
      return this.itemsFDayaDukungType.filter(item => item.statusActive && item.fdivisionBean>0 && item.description !=='' ).map((item) => {
        return {
          ...item,
          calcData: this.calculateDayaDukungNilaiAkhir(item),
        };
      });
    }
  },
  methods: {
    pdrbDialogShow(item) {
      this.$refs.refPdrbDialog.showDialog(item);
    },

    showDialog(item) {
      this.$refs.refDayaDukungBannerDialog.showDialog(item);
    },

    calculateDayaDukungNilaiAkhir(dayaDukungType) {
      let nilaiAkhir = 0;
      let tahunPalingAkhir = 0;
      let sumberAkhir = '';

      let itemsFDayaDukungFiltered = this.itemsFDayaDukung.filter((item) =>item.fdayaDukungTypeBean === dayaDukungType.id);
      itemsFDayaDukungFiltered.forEach((item) => {
        tahunPalingAkhir = Math.max(tahunPalingAkhir, item.tahun);
      });

      itemsFDayaDukungFiltered.filter((item) => item.tahun === tahunPalingAkhir).forEach(
          item =>{
            if (item.notes !== ''){
              sumberAkhir = item.notes;
            }
          }
      )

      nilaiAkhir = itemsFDayaDukungFiltered.filter(
        (item) => item.tahun === tahunPalingAkhir
      ) .map((item) => item.nilai1)
        .reduce((acc, cur) => acc + cur, 0);

      return { nilaiAkhir: nilaiAkhir, tahunPalingAkhir: tahunPalingAkhir, sumberAkhir: sumberAkhir };
    },

    formatter: function (val) {
      let value = val
      let valueStr = "";
      if (value / 1000000000000 > 1) {
        valueStr = `${parseFloat(value / 1000000000000).toFixed(
            2
        )} Triliun`;
      } else if (value / 1000000000 > 1) {
        valueStr = `${parseFloat(value / 1000000000).toFixed(2)} Miliar`;
      } else if (value / 1000000 > 1) {
        valueStr = `${parseFloat(value / 1000000).toFixed(2)} Juta`;
      } else if (value / 1000 > 1) {
        valueStr = `${parseFloat(value / 1000).toFixed(2)} Ribu`;
      } else {
        valueStr = value.toString();
      }
      return valueStr;
    },

    lookupImageUrlDayaDukungType(item) {
      if (item.avatarImage !== "") {
        return FileService.image_url_low(item.avatarImage);
      } else {
        return "./assets/images/support1.png";
      }
    },
    lookupImageUrlLazy(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/support1.png";
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },

  },
  mounted() {},
};
</script>

<style scoped>
@keyframes slide {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}
.logos {
  overflow: hidden;
  white-space: nowrap;
  /* position: relative; */
}
.logos:before,
.logos:after {
  top: 0;
  width: 250px;
  height: 100%;
  content: "";
  /* z-index: 2; */
}
.logos:before {
  left: 0;
  background: linear-gradient(
    to right,
    rgb(3, 12, 40, 0.5),
    rgba(255, 255, 255, 0)
  );
}
.logos:after {
  right: 0;
  background: linear-gradient(
    to left,
    rgb(3, 12, 40, 0.3),
    rgba(255, 255, 255, 0)
  );
}
.logos:hover .logos-slide {
  animation-play-state: paused;
}

.logos-slide {
  /* display: block; */
  animation: slide 9s linear infinite;
}
.width-text {
  width: 150px;
}
</style>